import React from 'react';
import PropTypes from 'prop-types';

import { ResourceComboboxConnected } from 'v5/patterns/resource/ResourceCombobox.connected';

import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { v4 as uuidv4 } from 'uuid';

export const getAgentData = newResource => {
  let agent = {};
  if (!isEmpty(newResource.emails)) {
    agent['email'] = {
      id: `temp-${uuidv4()}`,
      value_1: get(newResource.emails, [0, 'value_1']),
      value_2: 'agent'
    };
  }
  if (!isEmpty(newResource.phone_numbers)) {
    agent['phone_number'] = {
      id: `temp-${uuidv4()}`,
      value_1: get(newResource.phone_numbers, [0, 'value_1']),
      value_2: 'agent'
    };
  }
  if (newResource.organisation_id) {
    agent['organisation_id'] = newResource.organisation_id;
  }
  return agent;
};

// TODO: review this to bring in line with new form stuff
export const ResourceConnectFormBlock = ({
  value,
  onChange,
  field,
  resourceTypeModel = 'AGENT',
  disabled
}) => {
  function onResourceSelect(resourceId, newResource) {
    // TODO: extract out to settings / business logic - Only populate contact data if resource type model is AGENT
    if (newResource && get(newResource, 'resource_type.model') === 'AGENT') {
      const agent = getAgentData(newResource);
      return onChange(field, { resourceId, agent });
    }
    return onChange(field, { resourceId });
  }

  return (
    <div className="tailwind-root">
      <ResourceComboboxConnected
        disabled={disabled}
        value={value || null}
        onSelect={resource => onResourceSelect(resource.id, resource)}
        onClear={() => onResourceSelect(null)}
        filters={{
          resource_type_model: {
            operator: 'matchAny',
            value: [resourceTypeModel]
          }
        }}
        isCreatable={type => type.model === resourceTypeModel}
      />
    </div>
  );
};

ResourceConnectFormBlock.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  field: PropTypes.string,
  resourceTypeModel: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

export default ResourceConnectFormBlock;
